import { useState } from "react";

import { useAppBusEvent } from "./useAppBusEvent";

export function useAppSSEEventsFallbackPolling() {
  const [isFallbackPolling, setIsFallbackPolling] = useState(false);

  useAppBusEvent("sse.fallback-polling", ({ isFallbackPolling }) => {
    setIsFallbackPolling(isFallbackPolling);
  });

  return { isFallbackPolling };
}
